import { Component } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-modal-acoes-list',
  templateUrl: './modal-acoes-list.component.html',
  styleUrls: ['./modal-acoes-list.component.scss'],
})
export class ModalAcoesListComponent {

  constructor(private modalController: ModalController, private popoverController: PopoverController) { }

  actionBtn(action) {
    this.popoverController.dismiss(action);
  }

}
